import { Input } from "@/components/ui/input";

type MCAlertDestinationProps = {
  label: string;
  description?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export function MCAlertDestination({
  label,
  description,
  placeholder,
  value,
  onChange,
  disabled,
}: MCAlertDestinationProps) {
  return (
    <div className="rounded-2xl border border-border bg-background/60 p-4">
      <p className="text-sm font-semibold text-foreground">{label}</p>
      {description && <p className="text-xs text-muted-foreground">{description}</p>}
      <Input
        type="text"
        className="mt-3 bg-background/40 text-foreground"
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
}

export default MCAlertDestination;
